import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import LivroProfessorTable from './LivroProfessorTable';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

const LivroProfessorContainer = () => {
    const classes = useStyles();

    return (
        <Container className={classes.paper} component={Paper}>
            <Grid container justify="space-between">
                <Grid size={3}>
                    <Typography className={classes.title} variant="h6">
                        Livros Professor
                    </Typography>
                </Grid>


            </Grid>
            <Grid >
                <LivroProfessorTable />
            </Grid>
        </Container>
    );
}

export default LivroProfessorContainer;